import { observable, action } from 'mobx';
import reporter, { reportPageName } from '@/utils/report';
import { TRACKING_OPERATION, TRACKING_PAGE } from '@/utils/tracking/constants';
import { mdapReporter } from '@/utils/mdap/reporter';

interface HeartbeatInfo {
  flag: true;
  delay: number;
  retryTimes: number;
}

const init_heartbeat_info: HeartbeatInfo = {
  flag: true,
  delay: 10000,
  retryTimes: 1,
};

class PerformanceStore {
  // 首屏时间：html开始渲染到欢迎语出现
  @observable first_paint: number;

  @observable first_interactive: number;

  // 首屏关键接口请求时长：init_session
  @observable api_request: number;

  // 心跳用数据
  @observable heartbeat_info: HeartbeatInfo;

  constructor() {
    this.first_paint = 0;
    this.first_interactive = 0;
    this.api_request = 0;
    this.heartbeat_info = init_heartbeat_info;
  }

  @action
  SET_FIRST_PAINT(time: number) {
    this.first_paint = time;
  }

  @action
  SET_FIRST_INTERACTIVE(time: number) {
    console.log('first_interactive ====>', time);
    this.first_interactive = time;
  }

  @action
  SET_API_REQUEST(time: number) {
    this.api_request = time;
  }

  @action
  async SEND_TRACK() {
    const performance = window.performance || {};
    const time = performance.timing || {};

    reporter.biReport({
      page_type: TRACKING_PAGE.GAME_HIPO_TRACK,
      operation: TRACKING_OPERATION.ACTION_HIPO,
      data: {
        page_name: reportPageName,
        hipo_type: 'action_page_performance',
        json_str: JSON.stringify({
          first_paint: Math.floor(this.first_paint),
          first_interactive: Math.floor(this.first_interactive),
          first_static: 0,
          first_img: 0,
          first_api: Math.floor(this.api_request),
          ttfb: Math.floor(time.responseStart - time.navigationStart), // 首字节时长,
          dom_ready: Math.floor(time.domContentLoadedEventEnd - time.responseEnd), // DOM ready时长
          html: time.responseEnd - time.fetchStart,
          redirect: Math.floor(time.redirectEnd - time.redirectStart), // 重定向时长
          app_cache: Math.floor(time.domainLookupStart - time.fetchStart),
          dns: Math.floor(time.domainLookupEnd - time.domainLookupStart), // dns查找时间
          tcp: Math.floor(time.connectEnd - time.connectStart), // tcp连接时间
          stalled: time.requestStart - time.connectStart,
          network: 'unknown',
          has_offline_package: 0,
        }),
      },
    });
    // 发送埋点
    // dispatchTrack({
    //   operation: TRACKING_OPERATION.PERFORMANCE,
    //   data: {
    //     ttfb: Math.floor(time.responseStart - time.navigationStart), // 首字节时长
    //     first_paint: Math.floor(this.first_paint),
    //     api_request: Math.floor(this.api_request),
    //     dns: Math.floor(time.domainLookupEnd - time.domainLookupStart), // dns查找时间
    //     tcp: Math.floor(time.connectEnd - time.connectStart), // tcp连接时间
    //     resource_requests: JSON.stringify(performance?.getEntriesByType?.('resource')), // 资源请求明细
    //     appcache_time: Math.floor(time.domainLookupStart - time.fetchStart), // dns缓存时间
    //     redirect: Math.floor(time.redirectEnd - time.redirectStart), // 重定向时长
    //     dom_ready: Math.floor(time.domContentLoadedEventEnd - time.responseEnd), // DOM ready时长
    //   },
    //   usage_id: 1,
    // });

    mdapReporter.sendPagePerformance();
  }

  @action
  UPDATE_HEARTBEAT(info: any) {
    this.heartbeat_info = {
      ...this.heartbeat_info,
      ...info,
    };
  }

  @action
  INIT_HEARTBEAT() {
    this.heartbeat_info = init_heartbeat_info;
  }
}

const performanceStore = new PerformanceStore();

export default performanceStore;
